import { FC } from 'react';

import { Flex, Switch, SwitchProps, Typography } from 'antd';

interface ISwitchWithTextProps extends SwitchProps {
	subTitle?: string;
	children: React.ReactNode;
}

export const SwitchWithText: FC<ISwitchWithTextProps> = ({ className, subTitle, children, ...props }) => {
	return (
		<Flex gap={12} justify="space-between" className={className}>
			<Flex vertical gap={4}>
				<Typography.Text>{children}</Typography.Text>
				{!!subTitle && (
					<Typography.Text type="secondary" style={{ fontSize: 12 }}>
						{subTitle}
					</Typography.Text>
				)}
			</Flex>
			<Switch {...props} />
		</Flex>
	);
};
